import request from "@/utils/jcRequest.js";

 

// 网站获取导航菜单
export const getMenuList = (data: any) => {
    return request.get(`/sys/menu/listMenus`,data);
};

 
export const getUserMenuList = (data: any) => {
    return request.get(`/user/online/currentMenuInfo?classfier=${data}`);
};
 

// 删除菜单
export const delMenuList = (data: any) => {
    return request.delete(`/sys/menu/deleteMenu`,data);
};
 
// 查询所有父菜单
export const getParentMenuList = () => {
    return request.get(`/sys/menu/listAllParentMenus`);
};
// 新增菜单
export const putMenuList = (data: any) => {
    return request.put(`/sys/menu/insert`,data);
};
export const getMenuInfo = (id: any) => {
    return request.get(`/sys/menu/getMenuInfo?menuId=${id}`);
};
// 修改菜单
export const updMenuList = (data: any) => {
    return request.post(`/sys/menu/update`,data);
};

// 分页查询日志
export const getLogsList = (data: any) => {
    return request.get(`/sys/log/listLogs`,data);
};

// 分页查询系统参数
export const getParameterList = (data: any) => {
    return request.get(`/system/parameter/listParameters`,data);
};

// 新增参数
export const putParameter = (data: any) => {
    return request.put(`/system/parameter/insert`,data);
};
// 修改参数
export const updParametert = (data: any) => {
    return request.post(`/system/parameter/update`,data);
};
// 删除参数
export const delParametert = (data: any) => {
    return request.delete(`/system/parameter/delete`,data);
};

// 分页查询枚举
export const getEnumList = (data: any) => {
    return request.get(`/base/enum/listEnums`,data);
};

// 新增、修改枚举
export const putEnum = (data: any) => {
    return request.post(`/base/enum/add`,data);
};
// 删除枚举
export const delEnum = (data: any) => {
    return request.delete(`/base/enum/delete`,data);
};

// 分页查询用户列表
export const getUserList = (data: any) => {
    return request.get(`/user/user/listUsers`,data);
};


// 上传图片
export const uploadImg = (data: any) => {
    return request.post(`/sys/upload/img`,data);
};

 
// 查询所有职位
export const getAllPosts = () => {
    return request.get(`/base/post/selectAll`);
};
 
// 查询所有部门
export const getAllDepart = () => {
    return request.get(`/base/depart/listAllDeps`);
};
 
// 查询所有角色
export const getAllRole = () => {
    return request.get(`/sys/role/all`);
};

// 新增用户
export const putUser = (data: any) => {
    return request.post(`/user/user/add`,data);
};


// 删除用户
export const delUser = (data: any) => {
    return request.delete(`/user/user/delete`,data);
};
 
// 获取用户详情
export const getUserDetail = (id: any) => {
    return request.get(`/user/user/getUserDetail?userId=${id}`);
};

// 分页获取角色列表
export const getRoleList = (data: any) => {
    return request.get(`/sys/role/listRoles`,data);
};

// 删除角色
export const delRole = (data: any) => {
    return request.delete(`/sys/role/delete`,data);
};
 

// 新增角色
export const putRole = (data: any) => {
    return request.put(`/sys/role/insert`,data);
};

// 获取角色详情
export const getRoleDetail = (id: any) => {
    return request.get(`/sys/role/getRoleDetail?roleId=${id}`);
};

// 编辑角色
export const updRole = (data: any) => {
    return request.post(`/sys/role/update`,data);
};

// 分页获取部门列表
export const getDepartList = (data: any) => {
    return request.get(`/base/depart/listDeparts`,data);
};

// 新增部门
export const putDepart = (data: any) => {
    return request.post(`/base/depart/add`,data);
};

// 删除部门
export const delDepart = (data: any) => {
    return request.delete(`/base/depart/delete`,data);
};
// 分页获取职位列表
export const getPostList = (data: any) => {
    return request.get(`/base/post/listPosts`,data);
};

// 新增职位
export const putPost = (data: any) => {
    return request.post(`/base/post/add`,data);
};

// 删除职位
export const delPost = (data: any) => {
    return request.delete(`/base/post/delete`,data);
};

// 分页查询方案类型列表
export const getSchemeTypeList = (data: any) => {
    return request.get(`/core/schemeType/listTypes`,data);
};

// 新增方案类型
export const putSchemeType = (data: any) => {
    return request.post(`/core/schemeType/add`,data);
};

// 删除方案类型
export const delSchemeType = (data: any) => {
    return request.delete(`/core/schemeType/delete`,data);
};

// 分页查询招聘类型列表
export const getRecruitTypeList = (data: any) => {
    return request.get(`/base/recruitType/listRecruitTypes`,data);
};

// 新增招聘类型
export const putRecruitType = (data: any) => {
    return request.post(`/base/recruitType/add`,data);
};

// 删除招聘类型
export const delRecruitType = (data: any) => {
    return request.delete(`/base/recruitType/delete`,data);
};

// 分页查询应用场景
export const getUsageList = (data: any) => {
    return request.get(`/core/usageScene/listScenes`,data);
};

// 新增应用场景
export const putUsage = (data: any) => {
    return request.post(`/core/usageScene/add`,data);
};

// 删除应用场景
export const delUsage = (data: any) => {
    return request.delete(`/core/usageScene/delete`,data);
};


// 分页查询招商类型
export const getAttractTyp = (data: any) => {
    return request.get(`/core/attractType/listTypes`,data);
};

// 新增招商类型
export const putAttractTyp = (data: any) => {
    return request.post(`/core/attractType/add`,data);
};

// 删除招商类型
export const delAttractTyp = (data: any) => {
    return request.delete(`/core/attractType/delete`,data);
};


// 分页查询数字展厅
export const getGaller = (data: any) => {
    return request.get(`/core/gallery/listGalleries`,data);
};

// 新增数字展厅
export const putGaller = (data: any) => {
    return request.post(`/core/gallery/add`,data);
};

// 删除数字展厅
export const delGaller = (data: any) => {
    return request.delete(`/core/gallery/delete`,data);
};

// 分页查询新闻
export const getNwes = (data: any) => {
    return request.get(`/core/news/listNews`,data);
};

// 新增新闻
export const putNwes = (data: any) => {
    return request.post(`/core/news/add`,data);
};
// 获取新闻详情
export const getNewsInfo = (id: any) => {
    return request.get(`/core/news/getNewsInfo?newsId=${id}`);
};
// 删除新闻
export const delNwes = (data: any) => {
    return request.delete(`/core/news/delete`,data);
};
// 查询所有招聘类型
export const getAllRecruitType = () => {
    return request.get(`/base/recruitType/selectAll`);
};


// 分页查招聘
export const getRecruit = (data: any) => {
    return request.get(`/core/recruit/listRecruits`,data);
};

// 新增招聘
export const putRecruit = (data: any) => {
    return request.post(`/core/recruit/add`,data);
};

// 删除招聘
export const delRecruit = (data: any) => {
    return request.delete(`/core/recruit/delete`,data);
};

// 分页查询留言板
export const getMessage = (data: any) => {
    return request.get(`/core/message/listMessages`,data);
};

// 删除留言板
export const delMessage = (data: any) => {
    return request.delete(`/core/message/delete`,data);
};

// 分页查招商加盟
export const getAttract = (data: any) => {
    return request.get(`/core/attractInvestment/listAttracts`,data);
};

// 新增招商加盟
export const putAttract = (data: any) => {
    return request.post(`/core/attractInvestment/add`,data);
};

// 删除招商加盟
export const delAttract = (data: any) => {
    return request.delete(`/core/attractInvestment/delete`,data);
};
// 查询所有加盟类型
export const getAllAttractType = () => {
    return request.get(`/core/attractType/selectAll`);
};

// 分页查客户
export const getCustomer = (data: any) => {
    return request.get(`/core/customer/listCustomers`,data);
};

// 新增客户
export const putCustomer = (data: any) => {
    return request.post(`/core/customer/add`,data);
};

// 删除客户
export const delCustomer = (data: any) => {
    return request.delete(`/core/customer/delete`,data);
};
// 查询所有客户
export const getAllCustomerType = () => {
    return request.get(`/core/attractType/selectAll`);
};

// 分页查活动支持
export const getActive = (data: any) => {
    return request.get(`/core/activeSupport/listActives`,data);
};

// 新增客户
export const putActive = (data: any) => {
    return request.post(`/core/activeSupport/add`,data);
};

// 删除客户
export const delActive = (data: any) => {
    return request.delete(`/core/activeSupport/delete`,data);
};

// 分页查询应用案例
export const getUsageCase = (data: any) => {
    return request.get(`/core/use-case/listCases`,data);
};

// 新增应用案例
export const putUsageCase = (data: any) => {
    return request.post(`/core/use-case/add`,data);
};

// 删除应用案例
export const delUsageCase = (data: any) => {
    return request.delete(`/core/use-case/delete`,data);
};
// 分页查询解决方案
export const getSolution = (data: any) => {
    return request.get(`/core/solution/listSolutions`,data);
};

// 新增解决方案
export const putSolution = (data: any) => {
    return request.post(`/core/solution/add`,data);
};

// 删除解决方案
export const delSolution = (data: any) => {
    return request.delete(`/core/solution/delete`,data);
};
// 查询所有方案类型
export const getAllSolutionType = () => {
    return request.get(`/core/schemeType/selectAll`);
};
// 分页查询产品管理
export const getProduct = (data: any) => {
    return request.get(`/core/product/listProducts`,data);
};

// 新增产品管理
export const putProduct = (data: any) => {
    return request.post(`/core/product/add`,data);
};

// 删除产品管理
export const delProduct = (data: any) => {
    return request.delete(`/core/product/delete`,data);
};
// 获取所有应用场景
export const getAllUsage = () => {
    return request.get(`/core/usageScene/selectAll`);
};
// 查询产品详情
export const getProductInfo = (data: any) => {
    return request.get(`/core/product/getProductInfo?id=${data}`);
};

// 分页查询关于我们
export const getAbout = (data: any) => {
    return request.get(`/core/aboutUs/listAboutUs`,data);
};

// 新增关于我们
export const putAbout = (data: any) => {
    return request.post(`/core/aboutUs/add`,data);
};

// 删除关于我们
export const delAbout = (data: any) => {
    return request.delete(`/core/aboutUs/delete`,data);
};
 
// 查询关于我们详情
export const getAboutInfo = (data: any) => {
    return request.get(`/core/aboutUs/getAboutInfo?id=${data}`);
};

// 分页查询合作流程
export const getCooperative = (data: any) => {
    return request.get(`/base/cooperative-process/listProcess`,data);
};

// 新增合作流程
export const putCooperative = (data: any) => {
    return request.post(`/base/cooperative-process/add`,data);
};

// 删除合作流程
export const delCooperative = (data: any) => {
    return request.delete(`/base/cooperative-process/delete`,data);
};
// 新增留言
export const addMessage = (data: any) => {
    return request.put(`/core/message/add`,data);
};


// 新增代理加盟
export const addApply = (data: any) => {
    return request.post(`/core/agency-apply/add`,data);
};
// 分页查询代理申请
export const getApply = (data: any) => {
    return request.get(`/core/agency-apply/listApply`,data);
};
// 删除代理申请
export const delApply = (data: any) => {
    return request.delete(`/core/agency-apply/delete`,data);
};

 // 修改代理申请
export const putApply = (data: any) => {
    return request.put(`/core/agency-apply/updateDealStatus`,data);
};

//查询试题详情
export const getlistQuestions = (data: any) => {
    return request.get(`/core/question/listQuestions`,data);
};

//添加试题
export const addQuestions = (data: any) => {
    return request.post(`/core/question/add`,data);
};

//删除试题
export const deleteQuestions = (data: any) => {
    return request.delete(`/core/question/delete`,data);
};

//删除试题
export const getQuestionInfo = (data: any) => {
    return request.get(`/core/question/getQuestionInfo`,data);
};

//分页查询问卷
export const getListExams = (data: any) => {
    return request.get(`/core/exam/listExams`,data);
};

//新增/修改问卷
export const addExams = (data: any) => {
    return request.post(`/core/exam/add`,data);
};

//查询问卷详情
export const getExamInfo = (data: any) => {
    return request.get(`/core/exam/getExamInfo`,data);
};

//删除问卷
export const deleteExam = (data: any) => {
    return request.delete(`/core/exam/delete`,data);
};

//获取问卷二维码
export const getQrCode = (data: any) => {
    return request.get(`/core/exam/getQrCode`,data);
};

//分页查询问卷提交记录
export const getListExamUsers = (data: any) => {
    return request.get(`/core/exam-user/listExamUsers`,data);
};


 //问卷统计
export const getStatistics = (data: any) => {
    return request.get(`/core/question/statistics`,data);
};


 //问卷跳转链接
 export const getExamUrl = (data: any) => {
    return request.get(`/core/exam/getExamUrl`,data);
};
